// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popoverStyle{-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.5);box-shadow:0 2px 12px 0 rgba(0,0,0,.5)}.popoverStyle .el-popover__title{border-bottom:1px dashed #666;color:#666;text-align:center;font-weight:700;font-family:monospace}.popoverStyle i.title{font-style:normal}", ""]);
// Exports
module.exports = exports;
